import { render, staticRenderFns } from "./PlayBox.vue?vue&type=template&id=3b63a4e3&scoped=true&lang=pug&"
import script from "./PlayBox.vue?vue&type=script&lang=js&"
export * from "./PlayBox.vue?vue&type=script&lang=js&"
import style0 from "./PlayBox.vue?vue&type=style&index=0&id=3b63a4e3&scoped=true&lang=scss&"
import style1 from "./PlayBox.vue?vue&type=style&index=1&id=3b63a4e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b63a4e3",
  null
  
)

export default component.exports